import { getParamByISO } from 'iso-country-currency';

import { COUNTRY_CODE_EXCEPTION_MAP } from 'watchtower-ui/types/country';
import type { CountryISO } from 'watchtower-ui/types/country';

export const countryISOToName = (countryISO: CountryISO) => {
  try {
    return getParamByISO(countryISO, 'countryName');
  } catch {
    return countryISO;
  }
};

export const countryISOToCurrencySymbol = (countryISO: CountryISO) => {
  try {
    return getParamByISO(countryISO, 'symbol');
  } catch {
    return countryISO;
  }
};

export const normalizeCountryCode = (code: string): CountryISO => {
  // Normalizing country codes to uppercase
  let countryCode = code.toUpperCase();

  // Adding exception for country codes that differ
  if (COUNTRY_CODE_EXCEPTION_MAP[countryCode]) {
    countryCode = COUNTRY_CODE_EXCEPTION_MAP[countryCode]!;
  }

  return countryCode;
};

export const denormalizeCountryCode = (code: CountryISO): string => {
  // Reverse mapping for denormalization if needed
  const entry = Object.entries(COUNTRY_CODE_EXCEPTION_MAP).find(([, value]) => value === code);
  return entry ? entry[0] : code;
};
